export default __webpack_public_path__ + "static/GavulaXMas--2021-8933e7d78cc07aa1f2acdb28f1c30cc1.pdf";